/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import TeaserPatientDecree from "../../../assets/img/provision/teaser_patientenverfuegung_900px.jpg";
import TeaserProvisionPowerOfAttorney from "../../../assets/img/provision/teaser_vorsorgevollmacht_900px.jpg";

const provisionDocumentTeasersStyle = {
  teaserImagePatientDecree: {
    backgroundImage: "url(" + TeaserPatientDecree + ")",
    backgroundSize: "cover",
    width: "100%",
    minHeight: "150px",
    borderRadius: "5px",
  },
  teaserImageProvisionPowerOfAttorney: {
    backgroundImage: "url(" + TeaserProvisionPowerOfAttorney + ")",
    backgroundSize: "cover",
    width: "100%",
    minHeight: "150px",
    borderRadius: "5px",
  },
  teaserCard: {
    minHeight: "150px",
    padding: "5px",
    border: "1px solid #dadada",
    borderRadius: "5px",
    textAlign: "center",
    marginBottom: "8px",
  },
  teaserCardTextPatientDecree: {
    color: "text.primary",
    fontWeight: 500,
    marginBottom: "1rem",
  },
  teaserCardTextProvisionPowerOfAttorney: {
    color: "text.primary",
    fontWeight: 500,
    marginBottom: "1rem",
  },
  buttonContainer: {
    display: "inline-block",
  },
  button: {
    color: "primary.main",
    backgroundColor: "background.default",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "background.light",
    },
  },
};

export default provisionDocumentTeasersStyle;
